import ActionInterface from "../../Objects/interfaces/ActionInterface";
import {
    USER_CLIENT_SET_ACCOUNT,
    USER_CLIENT_UNSET_ACCOUNT,
    USER_CURRENT_REGISTER,
    USER_FIREBASE_MESSAGING_SET_TOKEN,
    USER_FIREBASE_SET_ACCOUNT,
    USER_FIREBASE_UNSET_ACCOUNT,
    USER_TEACHR_SET_ACCOUNT,
    USER_TEACHR_UNSET_ACCOUNT,
    FETCH_IMAGE_ACTIVE,
    SET_LOAD,
    USER_CURRENT_PROCURATION,
    GET_URSSAF_TDAE,
    USER_PROCURATION,
    USER_SET_INFO_SIRET,
    USER_SET_COOPERATIVE_FORM,
    USER_SET_SAP_FORM
} from "../Actions/UserActions";
import UserStateInterface from "../../Objects/interfaces/UserStateInterface";

export const initialState: UserStateInterface = {
    // firebase auth
    firebaseAuth: {
        userCredential: undefined,
        isAuthenticated: false,
        method: undefined,
    },

    // API entities
    currentUser: {
        isClient: false,
        client: undefined,
        isTeachr: false,
        teachr: undefined,
        isAuthenticated: false,
    },

    // firebase messaging
    firebaseMessaging: {
        token: undefined,
    },
    currentRegister: 1,
    profile: undefined,
    urssafTdae: undefined,
    load: { load: false, index: 1 },
    currentProcuration: 0,
    procuration: {},
    siretInfo: undefined,
    cooperativeFormData: undefined,
    sapFormData: undefined,

};

export default function userReducer(
    state = initialState,
    action: ActionInterface
): UserStateInterface {
    switch (action.type) {
        case USER_FIREBASE_SET_ACCOUNT:
            return {
                ...state,
                firebaseAuth: {
                    ...state.firebaseAuth,
                    userCredential: action.value.userCredential,
                    method: action.value.authMethod,
                    isAuthenticated: true,
                },
            };
        case USER_FIREBASE_UNSET_ACCOUNT:
            return { ...state, firebaseAuth: initialState.firebaseAuth };

        case USER_CLIENT_SET_ACCOUNT:
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    isClient: true,
                    client: action.value,
                    isTeachr: false,
                    teachr: undefined,
                    isAuthenticated: true,
                },
            };
        case USER_CLIENT_UNSET_ACCOUNT:
            return { ...state, currentUser: initialState.currentUser };

        case USER_TEACHR_SET_ACCOUNT:
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    isTeachr: true,
                    teachr: action.value,
                    isClient: false,
                    client: undefined,
                    isAuthenticated: true,
                },
            };
        case USER_TEACHR_UNSET_ACCOUNT:
            // L'étape d'inscription est persistée : on la remet à zéro à la déconnexion, sinon un compte
            // suivant hériterait d'une inscription « en cours » et perdrait Paramètres et Academy.
            return { ...state, currentUser: initialState.currentUser, currentRegister: 1 };
        case USER_FIREBASE_MESSAGING_SET_TOKEN:
            return {
                ...state,
                firebaseMessaging: {
                    ...state.firebaseMessaging,
                    token: action.value,
                },
            };
        case USER_CURRENT_REGISTER:
            return { ...state, currentRegister: action.value };
        case USER_CURRENT_PROCURATION:
            return { ...state, currentProcuration: action.value };
        case USER_PROCURATION:
            return { ...state, procuration: action.value };
        case FETCH_IMAGE_ACTIVE:
            return { ...state, profile: action.value };
        case GET_URSSAF_TDAE:
            return { ...state, urssafTdae: action.value };
        case SET_LOAD:
            return { ...state, load: action.value };
        case USER_SET_INFO_SIRET:
            return { ...state, siretInfo: action.value };
        case USER_SET_COOPERATIVE_FORM:
            return { ...state, cooperativeFormData: action.value };
        case USER_SET_SAP_FORM:
            return { ...state, sapFormData: action.value };
        default:
            return state;
    }
}
